import { useEffect } from 'react';

import { type IntersectionOptions, useInView } from 'react-intersection-observer';

interface Props extends IntersectionOptions {
  className?: string;
  onEnter?: () => void;
  onExit?: () => void;
}

const IntersectionTrigger = (options: Props) => {
  const { onEnter, onExit, className, ...rest } = options;
  const [ref, inView] = useInView(rest);

  useEffect(() => {
    if (inView && onEnter) {
      onEnter();
    } else if (!inView && onExit) {
      onExit();
    }
  }, [inView]);

  return <span ref={ref} className={className} />;
};

export default IntersectionTrigger;
